import styled from 'styled-components';

const SubConfiguration = styled.div`
  background: #f5f5f5;
  border: 0.0625rem solid #e0e5ea;
  border-radius: 0.25rem;
`;

const SubConfigurationItem = styled.div`
  background: #f5f5f5;
  border-top: 0.0625rem solid #e0e5ea;
  border-bottom: 0.0625rem solid #e0e5ea;
  padding: 0.625rem 1rem;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  margin-bottom: -0.0625rem;

  :first-child {
    border-top: 0;
    border-bottom: 0;
    margin-bottom: 0;
  }
`;

SubConfiguration.Item = SubConfigurationItem;
export default SubConfiguration;